/* -----------------Globals--------------- */
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@memorang/ui";
import { StyleSheet } from "react-native";

/* -----------------UI--------------- */
import { Surface } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";

/* -----------------Styles--------------- */
const getStyles = () =>
	StyleSheet.create({
		surface: {
			elevation: 4,
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			zIndex: 100000,
		},
	});

/* -----------------Props--------------- */
type Props = {
	children: React.ReactNode;
	isSummativeTest?: boolean;
};

export const BOTTOM_NAVIGATION_SESSION_HEIGHT = 64;

/* -----------------Component--------------- */
const BottomNavigationSession = (props: Props) => {
	const { children, isSummativeTest } = props;
	const styles = getStyles();
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const insets = useSafeAreaInsets();
	const insetBottom = Math.max(insets.bottom - 16, 0);
	const defaultHeight = BOTTOM_NAVIGATION_SESSION_HEIGHT;
	// TODO: Instead of absolute position, this should be outside of the ScrollView
	return (
		<Surface
			style={[
				styles.surface,
				{
					height: defaultHeight + insetBottom + (isMobile ? 0 : 16),
					display: "flex",
					flexDirection: "row",
					alignItems: isMobile ? "flex-start" : "center",
					paddingHorizontal: 16,
					paddingTop: isMobile ? 16 : 0,
					position: "absolute",
					bottom: 0,
					right: 0,
					left: 0,
					backgroundColor: isSummativeTest
						? theme.colors.surface
						: theme.colors.elevation.level1,
					borderTopWidth: isSummativeTest ? 1 : 0,
					borderTopColor: theme.colors.surfaceVariant,
					elevation: isSummativeTest ? 0 : 4,
				},
			]}
		>
			{children}
		</Surface>
	);
};

export default BottomNavigationSession;
